module.exports = __webpack_public_path__ + "img/new7.43cee9a1.png";